import { CloseCircleOutlined } from "@ant-design/icons";
import { Col, Empty, Input, Row, Select, Spin, Switch, message } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { apiSaveRegistrationCheckout } from "services/dashboardService";

const CheckoutTab = (props) => {
  const { Option } = Select;
  const { registrationID, settingInfo } = props;
  const userDataStore = useSelector((x) => x.userDataStore);

  const [isBusy, setIsBusy] = useState(false);
  const [errorField, setErrorField] = useState([]);
  const [discodeList, setDiscodeList] = useState([]);
  const [allowManualPayments, setAllowManualPayments] = useState(false);
  const [emailInvoicesToAdmin, setEmailInvoicesToAdmin] = useState(false);

  useEffect(() => {
    if (settingInfo != undefined) {
      let tmpDisList = Array.isArray(settingInfo.discount_codes)
        ? [...settingInfo.discount_codes]
        : [];
      tmpDisList = tmpDisList.map((x) => {
        return {
          ID: x.ID,
          visible: 1,
          text: x.discount_code,
          percentage: x.discount_percentage,
          amount: x.discount_amount,
          free: x.discount_free == "1" ? true : false,
          multipleList: [2, 3, 4, 5, 6],
          type: x.type,
          row_index: x.row_index,
        };
      });
      setDiscodeList(tmpDisList);

      setAllowManualPayments(
        settingInfo?.registration_info?.allow_manual_payments == 1
      );
      setEmailInvoicesToAdmin(
        settingInfo?.registration_info?.email_invoices_to_admin == 1
      );
    }
  }, [settingInfo]);

  const onAddCode = () => {
    let tmpList = [...discodeList];
    let oneCode = {
      text: "",
      percentage: "",
      amount: "",
      free: true,
      visible: 1,
      type: "single",
      row_index: "",
      multipleList: [2, 3, 4, 5, 6],
    };
    tmpList = [...tmpList, oneCode];
    setDiscodeList(tmpList);
  };

  const validateFields = () => {
    let errorList = Array();
    let isDuplicateRow = false;
    let tmpRow = "";
    let tmpList = [...discodeList];
    tmpList.map((x, index) => {
      if (x.type == "single") {
        if (!x.text || x.text === "") {
          errorList = [...errorList, index + "text"];
        }
      } else {
        if (!x.row_index || x.row_index === "") {
          errorList = [...errorList, index + "row_index"];
        } else {
          if (tmpRow != x.row_index) {
            tmpRow = x.row_index;
          } else {
            isDuplicateRow = true;
          }
        }
      }
      if (x.percentage == "" && x.amount == "") {
        errorList = [...errorList, index + "percentage"];
        errorList = [...errorList, index + "amount"];
      }
    });
    setErrorField([...errorList]);
    if (isDuplicateRow) {
      message.error("Participants row is duplicated.");
    }
    return errorList.length == 0 && !isDuplicateRow;
  };

  const onSave = () => {
    if (!validateFields()) return;

    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", registrationID);
    params.append("discount_code_list", JSON.stringify(discodeList));
    params.append(
      "allow_manual_payments",
      allowManualPayments ? "1" : "0"
    );
    params.append(
      "email_invoices_to_admin",
      emailInvoicesToAdmin ? "1" : "0"
    );

    setIsBusy(true);
    apiSaveRegistrationCheckout(params)
      .then((res) => {
        setIsBusy(false);
        if (res != undefined && Array.isArray(res.discount_code_list)) {
          let tmpList = [...res.discount_code_list.reverse()];
          tmpList = tmpList.map((x) => {
            return {
              ID: x.ID,
              visible: 1,
              text: x.discount_code,
              percentage: x.discount_percentage,
              amount: x.discount_amount,
              free: x.discount_free == "1" ? true : false,
              multipleList: [2, 3, 4, 5, 6],
              type: x.type,
              row_index: x.row_index,
            };
          });
          setDiscodeList(tmpList);
          message.success("Checkout settings saved successfully.");
        } else {
          message.success("Checkout settings saved.");
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  return (
    <div>
      <Spin spinning={isBusy}>
        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Allow Manual Payments
            </div>
            <Switch
              checkedChildren="Yes"
              unCheckedChildren="No"
              checked={allowManualPayments}
              style={{ marginBottom: 10 }}
              onChange={(e) => setAllowManualPayments(e)}
            />
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
              Email Invoices To Admin
            </div>
            <Switch
              checkedChildren="Yes"
              unCheckedChildren="No"
              checked={emailInvoicesToAdmin}
              style={{ marginBottom: 10 }}
              onChange={(e) => setEmailInvoicesToAdmin(e)}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          <Col>
            <div style={{ fontWeight: 600 }}>Discount Codes</div>
          </Col>
          <Col>
            <CommonButton onClick={onAddCode}>Add New</CommonButton>
          </Col>
        </Row>

        <div>
          {discodeList != undefined && discodeList.length > 0 ? (
            <div style={{ marginTop: 20 }}>
              {discodeList.map((x, index) => {
                if (x.visible == 1) {
                  return (
                    <Row
                      key={index}
                      gutter={[16, 16]}
                      style={{ marginTop: 10 }}
                      justify={"space-between"}
                      align={"bottom"}
                    >
                      <Col xs={24} sm={5}>
                        <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                          Code Type*
                        </div>
                        <Select
                          value={x.type}
                          className={
                            errorField !== undefined &&
                            errorField.includes(index + "type")
                              ? `common-select-error`
                              : `common-select`
                          }
                          onSelect={(v) => {
                            let errors = errorField.filter(
                              (y) =>
                                y != index + "type" &&
                                y != index + "text" &&
                                y != index + "row_index"
                            );
                            setErrorField([...errors]);

                            let tmpCodeList = [...discodeList];
                            tmpCodeList[index].type = v;
                            setDiscodeList(tmpCodeList);
                          }}
                        >
                          <Option value={"single"}>Discount</Option>
                          <Option value={"multiple"}>Multiple Participants</Option>
                        </Select>
                      </Col>
                      {x.type == "single" ? (
                        <Col xs={24} sm={5}>
                          <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                            Code Text*
                          </div>
                          <Input
                            value={x.text}
                            className={
                              errorField !== undefined &&
                              errorField.includes(index + "text")
                                ? `common-input-error`
                                : `common-input`
                            }
                            onChange={(e) => {
                              if (errorField.includes(index + "text")) {
                                let errors = errorField.filter((y) => y != index + "text");
                                setErrorField([...errors]);
                              }
                              let tmpCodeList = [...discodeList];
                              tmpCodeList[index].text = e.target.value;
                              setDiscodeList(tmpCodeList);
                            }}
                          />
                        </Col>
                      ) : (
                        <Col xs={24} sm={5}>
                          <div style={{ paddingBottom: "5px", fontWeight: 600 }}>
                            # of Participants*
                          </div>
                          <Select
                            value={x.row_index}
                            className={
                              errorField !== undefined &&
                              errorField.includes(index + "row_index")
                                ? `common-select-error`
                                : `common-select`
                            }
                            onSelect={(v) => {
                              if (errorField.includes(index + "row_index")) {
                                let errors = errorField.filter((y) => y != index + "row_index");
                                setErrorField([...errors]);
                              }
                              let tmpCodeList = [...discodeList];
                              tmpCodeList[index].row_index = v;
                              setDiscodeList(tmpCodeList);
                            }}
                          >
                            {x.multipleList.map((row, rowKey) => (
                              <Option value={row} key={rowKey}>
                                {row}
                              </Option>
                            ))}
                          </Select>
                        </Col>
                      )}
                      <Col xs={24} sm={5}>
                        <div style={{ paddingBottom: "5px", fontWeight: 600 }}>Percentage</div>
                        <Input
                          value={x.percentage}
                          type={"number"}
                          suffix="%"
                          className={
                            errorField !== undefined &&
                            errorField.includes(index + "percentage")
                              ? `common-input-error`
                              : `common-input`
                          }
                          onChange={(e) => {
                            if (
                              errorField.includes(index + "percentage") ||
                              errorField.includes(index + "amount")
                            ) {
                              let errors = errorField.filter((y) => y != index + "percentage");
                              errors = errorField.filter((y) => y != index + "amount");
                              setErrorField([...errors]);
                            }
                            let tmpCodeList = [...discodeList];
                            tmpCodeList[index].percentage = e.target.value;
                            setDiscodeList(tmpCodeList);
                          }}
                        />
                      </Col>
                      <Col xs={24} sm={5}>
                        <div style={{ paddingBottom: "5px", fontWeight: 600 }}>Amount</div>
                        <Input
                          value={x.amount}
                          type={"number"}
                          prefix="$"
                          suffix="USD"
                          className={
                            errorField !== undefined &&
                            errorField.includes(index + "amount")
                              ? `common-input-error`
                              : `common-input`
                          }
                          onChange={(e) => {
                            if (
                              errorField.includes(index + "percentage") ||
                              errorField.includes(index + "amount")
                            ) {
                              let errors = errorField.filter((y) => y != index + "percentage");
                              errors = errorField.filter((y) => y != index + "amount");
                              setErrorField([...errors]);
                            }
                            let tmpCodeList = [...discodeList];
                            tmpCodeList[index].amount = e.target.value;
                            setDiscodeList(tmpCodeList);
                          }}
                        />
                      </Col>
                      <Col>
                        <div style={{ paddingBottom: "5px", fontWeight: 600 }}>Free</div>
                        <Switch
                          checkedChildren="Free"
                          unCheckedChildren="Non"
                          checked={x.free}
                          style={{ marginBottom: 10 }}
                          onChange={(e) => {
                            let tmpCodeList = [...discodeList];
                            tmpCodeList[index].free = e;
                            setDiscodeList(tmpCodeList);
                          }}
                        />
                      </Col>
                      <Col>
                        <CloseCircleOutlined
                          style={{
                            color: "red",
                            marginBottom: 15,
                            cursor: "pointer",
                            fontSize: 16,
                          }}
                          onClick={() => {
                            let tmpCodeList = [...discodeList];
                            tmpCodeList[index].visible = 0;
                            setDiscodeList(tmpCodeList);
                          }}
                        />
                      </Col>
                    </Row>
                  );
                }
              })}
            </div>
          ) : (
            <Empty description="No codes" style={{ marginTop: 20 }} />
          )}
        </div>

        <div style={{ marginTop: 60, textAlign: "center" }}>
          <CommonButton style={{ padding: "12px 45px" }} onClick={onSave}>
            Save
          </CommonButton>
        </div>
      </Spin>
    </div>
  );
};

export default CheckoutTab;
